// This is used for inputs, selects and buttons
export enum InputSize {
  large = 500,
  medium = 240,
  medlarge = 375,
  small = 100,
  xs = 80,
  xxs = 62,
}

export enum HeightSize {
  large = 50,
  medium = 35,
  mediumLarge = 40,
}

// Form names
export const CUSTOMS_ITEM_FORM = 'CUSTOMS_ITEM_FORM';
export const CUSTOMS_DECLARATION_FORM = 'CUSTOMS_DECLARATION_FORM';
export const LABELS_DEFAULT_LABEL_FORMAT_FORM_NAME = 'LabelsDefaultForm';
export const LINE_ITEM_FORM = 'LINE_ITEM_FORM';

export const ADDITIONAL_SERVICES_FORM = 'ADDITIONAL_SERVICES_FORM';
export const PARCEL_FORM_NAME = 'ORDER_PARCEL_FORM';
export const COMPANY_FORM = 'company-form';

export const AUTOMATIONS_RULE_FORM = 'AUTOMATIONS_RULE_FORM';

export const CUSTOMS_OPT_OUT_FORM = 'CUSTOMS_OPT_OUT_FORM';
export const CARRIER_FORM = 'CARRIER_FORM';
export const ORDER_RECIPIENT_ADDRESS_FORM = 'ORDER_RECIPIENT_ADDRESS_FORM';

export type ExtrasFormType =
  | typeof ADDITIONAL_SERVICES_FORM
  | typeof CUSTOMS_OPT_OUT_FORM
  | typeof ORDER_RECIPIENT_ADDRESS_FORM;

// used to prevent HTML injection in several forms
export const SANITIZE_REGEX = /^[^<>()/\\=[\];:]+$/;
